import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import getInsuranceData from "../modals/getInsuranceData";
import Header_packages from "../components/Header_packages";
import Header from "../components/Header";
import { useLoading } from "../contexts/LoadingContext";
import "bootstrap/dist/css/bootstrap.min.css";

// ─── Rates Matrix ──────────────────────────────────────────────────────────────
// rates[plan][covtype][duration][zone]
// plan:    0=Elite, 1=Platinum, 2=Gold, 3=Silver, 4=Standard
// covtype: 0=Individual, 1=Family
// duration index 0–14 (see DURATION_LABELS)
// zone:    0=Zone1(Worldwide+USA/CAN/AUS), 1=Zone2(Worldwide ex USA/CAN/AUS), 2=Zone3(Europe)
// const user = {
//   openId: "5da34d83de18ba92f44040c10b406c8ad4bb1375",
//   unionId: "5ba759f37b91d2a51f20c014a7c3ba2a504055c7",
//   userMsisdn: "03145362496",
//   userName: "Khumash",
//   // applicationUserId: "27C62D9C-AB40-450C-A6CE-7851F47190FA",
//   // applicationUserId: "09ec867f-04ab-4ac2-ac76-896c68cfecab",
//   applicationUserId: "0d8968b7-65a9-4db6-84c3-8c8b3e67f946",
//   // applicationUserId: "2F02828E-B0E0-4570-9815-CDFBFB7D6DD0",
//   // userEmail: "03145362496@webdoc.com.pk",
//   // userEmail: "03145362496@kashtkaar.com.pk",
//   userEmail: "03145362496@vetdoctor.com.pk",
//   // applicationUserId: "B11000A1-70CA-4E67-A2A1-11DF65FEE0D9",
//   package: "",
//   message: "User registered and authenticated successfully  .",
// };

// sessionStorage.setItem("user", JSON.stringify(user));
// console.log(sessionStorage.getItem("user"));

const RATES = {
  0: {
    // Elite
    0: [
      // Individual
      [20.7, 17.4, 14.7],
      [23.8, 20.2, 17.2],
      [29.7, 25.3, 21.6],
      [34.2, 29.2, 24.9],
      [42.0, 35.8, 30.3],
      [65.3, 55.6, 47.3],
      [75.4, 64.0, 54.5],
      [90.3, 76.6, 65.2],
      [105.2, 89.3, 76.0],
      [132.7, 112.8, 95.8],
      [146.3, 124.4, 105.7],
      [160.1, 136.2, 115.7],
      [240.2, 204.5, 173.7],
      [320.2, 272.3, 231.3],
      [412.5, 352.0, 297.0],
    ],
    1: [
      // Family
      [39.4, 29.7, 23.8],
      [45.1, 34.5, 27.6],
      [56.3, 43.0, 34.5],
      [65.0, 49.6, 39.7],
      [79.9, 60.7, 48.4],
      [124.2, 88.8, 75.7],
      [143.1, 108.9, 84.5],
      [171.6, 130.5, 103.1],
      [199.9, 151.9, 121.7],
      [252.0, 191.6, 153.3],
      [278.1, 211.5, 169.2],
      [304.2, 231.4, 185.0],
      [456.2, 347.3, 277.5],
      [608.4, 463.0, 370.0],
      [775.5, 666.6, 562.1],
    ],
  },
  1: {
    // Platinum
    0: [
      [18.8, 15.8, 13.4],
      [21.6, 18.4, 15.6],
      [27.0, 23.0, 19.6],
      [31.1, 26.5, 22.6],
      [38.2, 32.5, 27.5],
      [59.4, 50.5, 43.0],
      [68.5, 58.2, 49.5],
      [82.1, 69.6, 59.3],
      [95.6, 81.2, 69.1],
      [120.6, 102.5, 87.1],
      [133.0, 113.1, 96.1],
      [145.5, 123.8, 105.2],
      [218.4, 185.9, 157.9],
      [291.1, 247.5, 210.3],
      [374.0, 319.0, 269.5],
    ],
    1: [
      [35.8, 27.0, 21.6],
      [41.0, 31.4, 25.1],
      [51.2, 39.1, 31.4],
      [59.1, 45.1, 36.1],
      [72.6, 55.2, 44.0],
      [112.9, 80.7, 68.8],
      [130.1, 99.0, 76.8],
      [156.0, 118.6, 93.7],
      [181.7, 138.1, 110.6],
      [229.1, 174.2, 139.4],
      [253.0, 192.5, 154.0],
      [276.5, 210.4, 168.2],
      [414.7, 315.7, 252.3],
      [553.1, 420.9, 336.4],
      [705.0, 606.1, 511.5],
    ],
  },
  2: {
    // Gold
    0: [
      [9.1, 7.7, 6.5],
      [11.4, 9.7, 8.4],
      [13.9, 11.9, 10.1],
      [16.8, 14.3, 12.3],
      [22.3, 19.0, 16.1],
      [28.2, 24.0, 20.4],
      [40.8, 34.7, 29.5],
      [50.5, 43.0, 36.5],
      [60.2, 51.3, 43.6],
      [61.3, 52.1, 44.3],
      [61.8, 52.6, 44.7],
      [62.4, 53.0, 45.1],
      [93.5, 79.6, 67.7],
      [124.7, 106.0, 90.2],
      [261.8, 223.3, 188.7],
    ],
    1: [
      [17.3, 13.1, 10.8],
      [21.8, 16.5, 12.4],
      [26.3, 20.2, 15.2],
      [32.0, 24.2, 19.7],
      [42.5, 32.3, 23.2],
      [53.5, 40.7, 34.7],
      [73.4, 59.0, 51.6],
      [81.8, 73.2, 58.5],
      [90.3, 87.2, 65.3],
      [101.3, 88.7, 67.7],
      [106.8, 89.4, 68.8],
      [112.3, 90.2, 70.0],
      [168.5, 135.3, 104.9],
      [224.6, 180.4, 139.9],
      [497.4, 424.3, 363.0],
    ],
  },
  3: {
    // Silver
    0: [
      [5.9, 5.3, 4.2],
      [7.4, 6.5, 5.4],
      [9.1, 8.1, 6.5],
      [10.9, 9.8, 7.9],
      [13.6, 12.1, 9.9],
      [18.4, 16.5, 13.3],
      [23.8, 21.3, 17.3],
      [28.1, 25.1, 20.4],
      [32.2, 28.8, 23.3],
      [41.1, 36.9, 29.7],
      [45.5, 40.8, 32.9],
      [49.9, 44.8, 36.1],
      [74.9, 67.1, 54.1],
      [99.9, 89.5, 72.2],
      [187.0, 160.8, 137.5],
    ],
    1: [
      [11.3, 8.9, 6.6],
      [14.0, 10.7, 8.6],
      [17.3, 12.2, 10.5],
      [20.7, 16.2, 12.7],
      [26.0, 20.6, 15.8],
      [35.0, 28.1, 21.2],
      [45.1, 36.2, 26.6],
      [53.2, 42.7, 32.0],
      [61.3, 49.1, 37.4],
      [78.1, 62.6, 47.5],
      [86.5, 69.3, 52.6],
      [94.8, 76.0, 57.6],
      [143.0, 114.1, 86.5],
      [189.6, 152.0, 115.3],
      [358.2, 305.5, 260.7],
    ],
  },
  4: {
    // Standard
    0: [
      [3.0, 2.8, 2.2],
      [3.5, 3.2, 2.5],
      [4.2, 3.7, 3.0],
      [6.4, 5.8, 4.5],
      [7.2, 6.3, 5.2],
      [12.9, 11.6, 9.4],
      [16.8, 15.1, 12.1],
      [22.6, 20.2, 16.3],
      [28.2, 25.3, 20.4],
      [33.2, 29.8, 24.0],
      [35.6, 32.0, 25.7],
      [38.2, 34.3, 27.5],
      [57.3, 51.5, 41.3],
      [76.3, 68.6, 55.0],
      [150.8, 128.6, 108.7],
    ],
    1: [
      [5.6, 4.4, 3.5],
      [6.8, 4.7, 4.1],
      [7.9, 5.3, 4.7],
      [12.0, 7.4, 6.6],
      [13.5, 8.8, 7.9],
      [24.4, 16.1, 14.9],
      [32.0, 27.1, 19.4],
      [42.8, 35.1, 26.1],
      [53.5, 43.0, 32.7],
      [63.0, 49.0, 38.4],
      [68.2, 51.9, 41.1],
      [72.6, 54.9, 44.0],
      [108.9, 82.5, 66.0],
      [145.2, 109.8, 88.0],
      [286.6, 244.4, 206.5],
    ],
  },
};

const PLAN_NAMES = ["Elite", "Platinum", "Gold", "Silver", "Standard"];
const PLAN_IDS = ["1031", "1032", "1033", "1034", "1035"]; // placeholder backend IDs
const MEDICAL_LIMITS = [
  "$150,000",
  "$100,000",
  "$50,000",
  "$25,000",
  "$10,000",
];
const PASSPORT_LIMITS = ["$600", "$500", "$400", "$300", "$200"];
const PA_LIMITS = ["$30,000", "$25,000", "$20,000", "$10,000", "$5,000"];
const ZONE_LABELS = [
  "Zone 1 — Worldwide incl USA / Canada / Australia",
  "Zone 2 — Worldwide excl USA / Canada / Australia",
  "Zone 3 — Europe",
];
const DURATION_LABELS = [
  "Up to 7 Days",
  "Up to 10 Days",
  "Up to 15 Days",
  "Up to 21 Days",
  "Up to 31 Days",
  "Up to 62 Days",
  "Up to 92 Days",
  "6 Months (Max 92 days/trip)",
  "6 Months (Max 180 days/trip)",
  "9 Months (Max 92 days/trip)",
  "9 Months (Max 180 days/trip)",
  "1 Year (Max 180 days/trip)",
  "2 Years (Max 92 days/trip)",
  "2 Years (Max 180 days/trip)",
  "Long Stay — 1 Year (365 days)",
];

const AGE_LOADING_TABLE = [
  {
    range: "Up to 65 years",
    pct: "0%",
    label: "Standard Premium",
    note: "No loading",
  },
  {
    range: "66 – 75 years",
    pct: "+50%",
    label: "+50%",
    note: "Health declaration required",
  },
  {
    range: "76 – 80 years",
    pct: "+75%",
    label: "+75%",
    note: "Health declaration required",
  },
  {
    range: "81 – 85 years",
    pct: "+100%",
    label: "+100%",
    note: "Health declaration + SIMA preapproval",
  },
  {
    range: "86 – 90 years",
    pct: "+200%",
    label: "+200%",
    note: "Health declaration + SIMA preapproval",
  },
];

const KEY_NOTES = [
  "Policy valid for insured aged 30 days – 85 years (86–90 requires SIMA preapproval).",
  "Maximum trip duration: 180 consecutive days per trip.",
  "Family = 2 named adults under 65 + any number of children under 18, travelling together.",
  "COVID-19 covered only if PCR+ ≥72 hours after arrival at destination; max 10 days hospitalisation.",
  "One-way tickets and open tickets are NOT covered; return ticket must be booked before departure.",
  "Policy extension available up to 62 days (+100% of paid premium, 7-day waiting period).",
  "Claims must be submitted within 30 days of occurrence / first treatment.",
  "Pre-existing, congenital, chronic, and psychiatric conditions are excluded.",
];

// Age loading formula: Final Premium = Base × (1 + Age Loading)
const getAgeLoading = (age) => {
  if (age <= 65) return { rate: 0, label: "No loading", note: "" };
  if (age <= 75)
    return { rate: 0.5, label: "+50%", note: "Health declaration required" };
  if (age <= 80)
    return { rate: 0.75, label: "+75%", note: "Health declaration required" };
  if (age <= 85)
    return {
      rate: 1.0,
      label: "+100%",
      note: "Health declaration + SIMA preapproval",
    };
  if (age <= 90)
    return {
      rate: 2.0,
      label: "+200%",
      note: "Health declaration + SIMA preapproval",
    };
  return null;
};

const TermsModal = ({ show, handleClose, terms }) => (
  <Modal
    show={show}
    onHide={handleClose}
    centered
    backdrop="static"
    dialogClassName="terms-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>Terms And Conditions</Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0 terms-body">
      <iframe
        src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
          `https://miniapp.webdoc.com.pk/${terms}`,
        )}`}
        className="terms-iframe"
        title="Terms PDF"
        style={{ width: "100%", height: "60vh", border: "none" }}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Ok
      </Button>
    </Modal.Footer>
  </Modal>
);

// ─── Shared select style ───────────────────────────────────────────────────────
const selectStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1.5px solid #dee2e6",
  borderRadius: "8px",
  fontSize: "13px",
  color: "#212529",
  backgroundColor: "#fff",
  appearance: "none",
  WebkitAppearance: "none",
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236c757d' d='M6 8L0 0h12z'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 12px center",
  paddingRight: "32px",
  cursor: "pointer",
};

const TRAVEL_API_BASE =
  "https://miniappeasypaisa.webddocsystems.com/public/api/v1";
const AUTH_HEADER =
  "Basic ZlJqZGZVbWFzOmFmMzNhZmNhODAwNzZkOWMxMTViOGU0NjAyZjc4YTIx";

// ─── Active Subscription View ─────────────────────────────────────────────────
const TravelActiveSubscription = ({
  subscription,
  customerNumber,
  terms,
  onUnsubscribe,
}) => {
  const { setIsLoading } = useLoading();
  const [showDetails, setShowDetails] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showAllRows, setShowAllRows] = useState(false);
  const rows = [
    ["Plan", subscription.planName],
    ["Coverage Zone", subscription.coverageZoneLabel],
    ["Coverage Type", subscription.coverageTypeLabel],
    ["Trip Duration", subscription.tripDurationLabel],
    ["Age of Insured", subscription.ageOfInsured + " years"],
    ["Medical Coverage", subscription.medicalCoverageLimit],
    ["Medical Deductible", subscription.medicalDeductible],
    ["Base Premium", "$" + subscription.basePremiumUSD + " USD"],
    ["Age Loading", subscription.ageLoadingLabel],
    ["Final Premium (USD)", "$" + subscription.finalPremiumUSD + " USD"],
    [
      "Final Premium (PKR)",
      "Rs. " + Number(subscription.finalPremiumPKR).toLocaleString("en-PK"),
    ],
    ["Transaction ID", subscription.transactionID],
    ["Payment Status", subscription.paymentStatus],
    [
      "Activated At",
      subscription.activatedAt ? subscription.activatedAt.split(".")[0] : "—",
    ],
  ];

  const handleUnsubscribe = async () => {
    const confirm = await Swal.fire({
      icon: "warning",
      title: "Unsubscribe?",
      text: "Are you sure you want to cancel your Travel Insurance subscription?",
      showCancelButton: true,
      confirmButtonText: "Yes, Unsubscribe",
      cancelButtonText: "No, Keep it",
      confirmButtonColor: "#d33",
    });
    if (!confirm.isConfirmed) return;

    setIsLoading(true);
    try {
      const res = await fetch(
        `${TRAVEL_API_BASE}/travel-insurance/unsubscribe`,
        {
          method: "POST",
          body: JSON.stringify({
            customerNumber: customerNumber,
            subscriptionID: subscription.id || subscription.subscriptionID,
          }),
        },
      );
      const data = await res.json();
      if (data?.responseCode === "0000") {
        Swal.fire({
          icon: "success",
          title: "Unsubscribed",
          text: "Your subscription has been cancelled.",
        });
        onUnsubscribe();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data?.message || "Could not unsubscribe. Please try again.",
        });
      }
    } catch (err) {
      console.error("Unsubscribe error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-2 pb-5">
      {/* Status Banner */}
      <div
        className="rounded-3 text-white text-center py-4 mb-3"
        style={{ background: "linear-gradient(135deg, #1bb367, #0d9356)" }}
      >
        <div style={{ fontSize: "40px" }}>✈️</div>
        <p className="mb-1 fw-bold" style={{ fontSize: "18px" }}>
          Travel Insurance Active
        </p>
        <p className="mb-0" style={{ fontSize: "13px", opacity: 0.85 }}>
          {subscription.planName} Plan — {subscription.coverageTypeLabel}
        </p>
        <div
          className="d-inline-block mt-2 px-3 py-1 rounded-pill fw-bold"
          style={{ backgroundColor: "rgba(255,255,255,0.2)", fontSize: "22px" }}
        >
          Rs. {Number(subscription.finalPremiumPKR).toLocaleString("en-PK")}
        </div>
      </div>

      {/* Collapsible Details Card */}
      {/* {showDetails && (
        <div className="card overflow-hidden mb-3">
          <div
            className="text-white text-center py-2 fw-bold"
            style={{
              backgroundColor: "#1bb367",
              fontSize: "12px",
              letterSpacing: "0.08em",
            }}
          >
            SUBSCRIPTION DETAILS
          </div>
          {rows.map(([label, value], idx) => (
            <div
              key={idx}
              className="d-flex justify-content-between align-items-center px-3 py-2"
              style={{
                borderBottom:
                  idx < rows.length - 1 ? "1px solid #f0ebe0" : "none",
                fontSize: "13px",
              }}
            >
              <span style={{ color: "#6b6254" }}>{label}</span>
              <span
                className="fw-bold text-end ms-2"
                style={{ color: "#0d4f5c", maxWidth: "55%" }}
              >
                {value}
              </span>
            </div>
          ))}
        </div>
      )} */}
      <div className="card overflow-hidden mb-3">
        <div
          className="text-white text-center py-2 fw-bold"
          style={{
            backgroundColor: "#1bb367",
            fontSize: "12px",
            letterSpacing: "0.08em",
          }}
        >
          SUBSCRIPTION DETAILS
        </div>

        {(showAllRows ? rows : rows.slice(0, 4)).map(([label, value], idx) => (
          <div
            key={idx}
            className="d-flex justify-content-between align-items-center px-3 py-2"
            style={{
              borderBottom: "1px solid #f0ebe0",
              fontSize: "13px",
            }}
          >
            <span style={{ color: "#6b6254" }}>{label}</span>

            <span
              className="fw-bold text-end ms-2"
              style={{ color: "#0d4f5c", maxWidth: "55%" }}
            >
              {value}
            </span>
          </div>
        ))}

        {rows.length > 4 && (
          <div className="text-center p-2">
            <button
              style={{
                backgroundColor: showAllRows ? "#e8f5ef" : "#1bb367",
                color: showAllRows ? "#1bb367" : "#fff",
                border: "2px solid #1bb367",
                fontSize: "14px",
                cursor: "pointer",
              }}
              className="btn btn-sm btn-outline-secondary rounded-pill px-3"
              onClick={() => setShowAllRows(!showAllRows)}
            >
              {showAllRows ? "View less ▲" : "View More ▼"}
            </button>
          </div>
        )}
      </div>
      {/* Terms & Conditions */}
      {/* <p className="text-center mb-3" style={{ fontSize: "12px", color: "#6b7280" }}>
                By subscribing you have accepted our{" "}
                <span
                    style={{ color: "#1bb367", fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => setShowTerms(true)}
                >
                    Terms &amp; Conditions
                </span>
            </p> */}

      {/* Unsubscribe Button */}
      <button
        className="w-100 py-2 rounded-3 fw-bold"
        style={{
          backgroundColor: "#fff",
          color: "#dc3545",
          border: "2px solid #dc3545",
          fontSize: "14px",
          cursor: "pointer",
        }}
        onClick={handleUnsubscribe}
      >
        Unsubscribe
      </button>

      <p className="text-center text-muted mt-3" style={{ fontSize: "11px" }}>
        For support call: <strong>+92 42 111 000 420</strong>
      </p>

      {/* Terms Modal */}
      <TermsModal
        show={showTerms}
        handleClose={() => setShowTerms(false)}
        terms={terms}
      />
    </div>
  );
};

// ─── TravelScreen ─────────────────────────────────────────────────────────────
const TravelScreen = ({ terms, onSubscriptionSuccess, userData }) => {
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();

  const [plan, setPlan] = useState(0); // 0=Elite … 4=Standard
  const [zone, setZone] = useState(0); // 0=Z1, 1=Z2, 2=Z3
  const [covtype, setCovtype] = useState(0); // 0=Individual, 1=Family
  const [duration, setDuration] = useState(0); // 0–14
  const [age, setAge] = useState("18");
  const [ageError, setAgeError] = useState("");
  const [result, setResult] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [show, setShow] = useState(false);
  const [pkrRate, setPkrRate] = useState(281); // fallback rate
  const [rateStatus, setRateStatus] = useState("loading"); // "loading" | "live" | "fallback"
  const [showAllCoverage, setShowAllCoverage] = useState(false);
  const [showAllNotes, setShowAllNotes] = useState(false);
  // ── Fetch live USD → PKR exchange rate ─────────────────────────────────────
  useEffect(() => {
    fetch("https://open.er-api.com/v6/latest/USD")
      .then((r) => r.json())
      .then((data) => {
        if (data?.rates?.PKR) {
          setPkrRate(parseFloat(data.rates.PKR.toFixed(4)));
          setRateStatus("live");
        } else {
          setRateStatus("fallback");
        }
      })
      .catch(() => setRateStatus("fallback"));
  }, []);

  // ── Live calculation ────────────────────────────────────────────────────────
  useEffect(() => {
    const ageNum = parseInt(age);

    if (!age || isNaN(ageNum)) {
      setResult(null);
      setAgeError("");
      return;
    }

    if (ageNum < 18 || ageNum > 90) {
      setAgeError("Age must be between 18–90 years.");
      setResult(null);
      return;
    }
    setAgeError("");
    const info = getAgeLoading(ageNum);

    const base = RATES[plan][covtype][duration][zone];
    console.log(base);

    const final = base * (1 + info.rate);
    let deductible = "USD 100";
    if (ageNum > 85) deductible = "USD 300";
    else if (ageNum > 70) deductible = "USD 150";
    const deductibleUsd = ageNum > 85 ? 300 : ageNum > 70 ? 150 : 100;
    setResult({
      base,
      loading: info,
      final: parseFloat(final.toFixed(2)),
      deductible,
      deductibleUsd,
    });
  }, [plan, zone, covtype, duration, age]);

  // ── Pay Now ─────────────────────────────────────────────────────────────────
  const fmtPKR = (usd) => Math.round(usd * pkrRate).toLocaleString("en-PK");

  const handlePayNow = useCallback(async () => {
    if (!result) {
      Swal.fire({
        icon: "info",
        title: "Age Required",
        text: "Please enter the age of the insured before proceeding.",
      });
      return;
    }

    const pkrAmount = Math.round(result.final * pkrRate);

    try {
      setIsLoading(true);
      const form = new FormData();
      form.append("value", pkrAmount);
      form.append("apikey", "Travel");
      const response = await fetch(`${TRAVEL_API_BASE}/create-payment`, {
        method: "POST",
        body: form,
      });
      const res = await response.json();
      if (res.paymentTransactionID) {
        window.mp.createPayment(res.paymentTransactionID);
      }
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setIsLoading(false);
    }

    window.createPaymentResult = (jsonResult) => {
      const res = JSON.parse(jsonResult);
      setIsLoading(true);
      navigate("/confirm", {
        state: {
          type: "travel",
          apikey: "Travel",
          price: pkrAmount,
          pid: PLAN_IDS[plan],
          planName: PLAN_NAMES[plan],
          zone: ZONE_LABELS[zone],
          coverageType: covtype === 0 ? "Individual" : "Family",
          duration: DURATION_LABELS[duration],
          age: parseInt(age),
          baseAmount: result.base,
          loadingRate: result.loading.rate,
          finalAmount: result.final,
          medicalLimit: MEDICAL_LIMITS[plan],
          passportLimit: PASSPORT_LIMITS[plan],
          paLimit: PA_LIMITS[plan],
          deductible: result.deductible,
          status: res.paymentStatus,
          code: res.resultCode,
          tid: res.paymentTransactionID,
        },
      });
    };
  }, [
    result,
    plan,
    zone,
    covtype,
    duration,
    age,
    pkrRate,
    navigate,
    setIsLoading,
  ]);

  const activeAgeRange = (ageNum) => {
    if (ageNum <= 65) return 0;
    if (ageNum <= 75) return 1;
    if (ageNum <= 80) return 2;
    if (ageNum <= 85) return 3;
    return 4;
  };
  const currentAgeRow =
    age && !isNaN(parseInt(age)) ? activeAgeRange(parseInt(age)) : -1;

  const COVERAGE_DETAILS = [
    ["Emergency Medical (Accident/Illness)", MEDICAL_LIMITS[plan], true],
    ["COVID-19 Emergency Medical", "$35,000 (all plans)", false],
    ["Emergency Dental Care", "$600 (Excess: $60)", false],
    ["Medical Evacuation & Repatriation", "Actual Expenses", true],
    ["Repatriation of Mortal Remains", "Actual Expenses", true],
    ["Compassionate Visit (Family Member)", "$100/day, Max $1,000", false],
    ["Trip Cancellation", "$1,000", false],
    ["Delayed Departure", "$1,000", false],
    ["Loss of Checked-In Luggage", "$1,000", false],
    ["Loss of Passport", PASSPORT_LIMITS[plan], false],
    ["Loss of Credit Card (first 24 hrs)", "$2,000", false],
    ["Accidental Death (Common Carrier)", PA_LIMITS[plan], false],
    ["Bail Bond Advance", "$12,000", false],
    ["24/7 Assistance Services", "Included", true],
  ];

  return (
    <div className="container pb-5">
      <div style={{ marginBottom: "150px" }}>
        {/* ── Plan Type (Radio Buttons) ─────────────────────────────── */}
        <div className="row mt-2">
          <div className="col-12">
            <p className="fw-bold mt-2 mb-1" style={{ fontSize: "14px" }}>
              Select Plan Type
            </p>
          </div>
          <div className="col-12">
            <div className="card mb-3">
              <div className="packages_list">
                {PLAN_NAMES.map((name, idx) => (
                  <Button
                    key={idx}
                    variant="outline-light"
                    className="w-100 p-2 py-3 d-flex text-dark align-items-center border-0 border-bottom rounded-0 bg__active"
                    onClick={() => setPlan(idx)}
                  >
                    <div className="grow text-start">
                      <p className="mb-0 fw-bold" style={{ fontSize: "17px" }}>
                        {name}
                      </p>
                      <p
                        className="mb-0 text-secondary"
                        style={{ fontSize: "11px" }}
                      >
                        Emergency Medical: {MEDICAL_LIMITS[idx]} · PA:{" "}
                        {PA_LIMITS[idx]}
                      </p>
                    </div>
                    <div className="shrink-0 me-2">
                      <div
                        className={`package_radio ${plan === idx ? "package_radio_active" : ""}`}
                      ></div>
                    </div>
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── Policy Inputs ─────────────────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
              Policy Details
            </p>
            <div className="card p-3 mb-3">
              {/* Coverage Zone */}
              <div className="mb-3">
                <label
                  className="form-label mb-1"
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    letterSpacing: "0.07em",
                    textTransform: "uppercase",
                    color: "#6c757d",
                  }}
                >
                  Coverage Zone
                </label>
                <select
                  style={selectStyle}
                  value={zone}
                  onChange={(e) => setZone(parseInt(e.target.value))}
                >
                  {ZONE_LABELS.map((z, i) => (
                    <option key={i} value={i}>
                      {z}
                    </option>
                  ))}
                </select>
              </div>

              {/* Coverage Type */}
              <div className="mb-3">
                <label
                  className="form-label mb-1"
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    letterSpacing: "0.07em",
                    textTransform: "uppercase",
                    color: "#6c757d",
                  }}
                >
                  Coverage Type
                </label>
                <select
                  style={selectStyle}
                  value={covtype}
                  onChange={(e) => setCovtype(parseInt(e.target.value))}
                >
                  <option value={0}>Individual</option>
                  <option value={1}>Family</option>
                </select>
              </div>

              {/* Trip Duration */}
              <div className="mb-3">
                <label
                  className="form-label mb-1"
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    letterSpacing: "0.07em",
                    textTransform: "uppercase",
                    color: "#6c757d",
                  }}
                >
                  Trip Duration
                </label>
                <select
                  style={selectStyle}
                  value={duration}
                  onChange={(e) => setDuration(parseInt(e.target.value))}
                >
                  {DURATION_LABELS.map((d, i) => (
                    <option key={i} value={i}>
                      {d}
                    </option>
                  ))}
                </select>
              </div>

              {/* Age */}
              <div className="mb-0">
                <label
                  className="form-label mb-1"
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    letterSpacing: "0.07em",
                    textTransform: "uppercase",
                    color: "#6c757d",
                  }}
                >
                  Age of Insured (years)
                </label>
                <input
                  type="number"
                  min="18"
                  max="90"
                  className="form-control"
                  placeholder="Enter age (18 – 90)"
                  value={age}
                  onInput={(e) => {
                    if (e.target.value > 90) e.target.value = 90;
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAge(value); // always update input

                    if (value === "") {
                      setAgeError("");
                      return;
                    }

                    const num = parseInt(value);

                    if (num < 18 || num > 90) {
                      setAgeError("Age must be between 18 and 90 years.");
                    } else {
                      setAgeError("");
                    }
                  }}
                  style={{ fontSize: "14px", fontWeight: 600 }}
                />
                {ageError ? (
                  <small className="text-danger">{ageError}</small>
                ) : (
                  <small className="text-muted" style={{ fontSize: "11px" }}>
                    Valid range: 1–85 years (86–90 requires SIMA preapproval)
                  </small>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Exchange Rate Badge ───────────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex align-items-center justify-content-between px-3 py-2 rounded-2 mb-2"
              style={{
                backgroundColor: rateStatus === "live" ? "#e8f5ec" : "#fff3cd",
                border: "1px solid",
                borderColor: rateStatus === "live" ? "#b2dfdb" : "#ffc107",
                fontSize: "12px",
              }}
            >
              <span style={{ color: "#6b6254" }}>
                {rateStatus === "loading" && "⏳ Fetching live exchange rate…"}
                {rateStatus === "live" && "🟢 Live rate · 1 USD ="}
                {rateStatus === "fallback" && "⚠️ Using offline rate · 1 USD ="}
              </span>
              {rateStatus !== "loading" && (
                <span className="fw-bold" style={{ color: "#0d4f5c" }}>
                  PKR {pkrRate.toLocaleString("en-PK")}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* ── Premium Result ────────────────────────────────────────── */}
        {result && (
          <div className="row">
            <div className="col-12">
              <div className="card mb-3 overflow-hidden">
                <div
                  className="text-white text-center py-2 fw-bold"
                  style={{
                    backgroundColor: "#1bb367",
                    fontSize: "12px",
                    letterSpacing: "0.08em",
                  }}
                >
                  PREMIUM RESULT — {PLAN_NAMES[plan].toUpperCase()} PLAN
                </div>

                {/* PKR Final Premium Highlight */}
                <div
                  className="text-center py-3"
                  style={{
                    backgroundColor: "#0d4f5c",
                    borderBottom: "1px solid #dee2e6",
                  }}
                >
                  <small
                    className="d-block"
                    style={{
                      fontSize: "10px",
                      letterSpacing: "0.1em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,0.6)",
                    }}
                  >
                    Final Premium Payable (PKR)
                  </small>
                  <p
                    className="mb-0 fw-bold"
                    style={{ fontSize: "36px", color: "#d4a843" }}
                  >
                    Rs. {fmtPKR(result.final)}
                  </p>
                  <small
                    style={{
                      color: "rgba(255,255,255,0.55)",
                      fontSize: "12px",
                    }}
                  >
                    ${result.final.toFixed(2)} USD
                  </small>
                </div>

                <table className="table table-sm table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontSize: "12px",
                          color: "#6c757d",
                          width: "55%",
                        }}
                      >
                        Base Premium (USD)
                      </td>
                      <td className="fw-bold text-end">
                        ${result.base.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "12px", color: "#6c757d" }}>
                        Base Premium (PKR)
                      </td>
                      <td className="fw-bold text-end">
                        Rs. {fmtPKR(result.base)}
                      </td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor:
                          result.loading.rate > 0 ? "#fff8e1" : undefined,
                      }}
                    >
                      <td style={{ fontSize: "12px", color: "#6c757d" }}>
                        Age Loading
                        {result.loading.note ? (
                          <>
                            <br />
                            <small
                              className="text-muted"
                              style={{ fontSize: "10px" }}
                            >
                              {result.loading.note}
                            </small>
                          </>
                        ) : null}
                      </td>
                      <td
                        className="fw-bold text-end"
                        style={{
                          color:
                            result.loading.rate > 0 ? "#b8860b" : "#1a5c2e",
                        }}
                      >
                        {result.loading.label}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "12px", color: "#6c757d" }}>
                        Medical Deductible
                      </td>
                      <td className="fw-bold text-end">
                        Rs.{" "}
                        {Math.round(
                          result.deductibleUsd * pkrRate,
                        ).toLocaleString("en-PK")}
                      </td>
                    </tr>
                    <tr className="table-success">
                      <td className="fw-bold" style={{ fontSize: "13px" }}>
                        Final Premium (PKR)
                        <br />
                        <small
                          className="fw-normal text-muted"
                          style={{ fontSize: "10px" }}
                        >
                          Base × (1 + Age Loading) × PKR rate
                        </small>
                      </td>
                      <td
                        className="fw-bold text-end"
                        style={{ fontSize: "18px", color: "#0d4f5c" }}
                      >
                        Rs. {fmtPKR(result.final)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ── Coverage Details ──────────────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
              Coverage Details — {PLAN_NAMES[plan]} Plan
            </p>
            <div className="card mb-3">
              <div className="card mb-3">
                {(showAllCoverage
                  ? COVERAGE_DETAILS
                  : COVERAGE_DETAILS.slice(0, 3)
                ).map(([label, value, green]) => (
                  <div
                    key={label}
                    className="d-flex justify-content-between align-items-center px-3 py-2"
                    style={{
                      borderBottom: "1px solid #f0ebe0",
                      fontSize: "12.5px",
                    }}
                  >
                    <span style={{ color: "#6b6254", flex: 1 }}>{label}</span>

                    <span
                      className="fw-bold ms-2 text-end"
                      style={{
                        minWidth: "90px",
                        fontSize: "12px",
                        color: green ? "#1a5c2e" : "#0d4f5c",
                      }}
                    >
                      {value}
                    </span>
                  </div>
                ))}

                {COVERAGE_DETAILS.length > 3 && (
                  <div className="text-center p-2">
                    <button
                      style={{
                        backgroundColor: showAllCoverage
                          ? "#e8f5ef"
                          : "#1bb367",
                        color: showAllCoverage ? "#1bb367" : "#fff",
                        border: "2px solid #1bb367",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      className="btn btn-success btn-outline-secondary rounded-pill px-3"
                      onClick={() => setShowAllCoverage(!showAllCoverage)}
                    >
                      {showAllCoverage ? "Show Less ▲" : "Show More ▼"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Age Loading Reference Table ───────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
              Age Premium Loading Reference
            </p>
            <div className="card mb-3">
              {AGE_LOADING_TABLE.map((row, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center px-3 py-2"
                  style={{
                    borderBottom:
                      idx < AGE_LOADING_TABLE.length - 1
                        ? "1px solid #f0ebe0"
                        : "none",
                    backgroundColor:
                      currentAgeRow === idx ? "#fff8e1" : undefined,
                    fontSize: "12px",
                  }}
                >
                  <span style={{ flex: "0 0 100px", color: "#6b6254" }}>
                    {row.range}
                  </span>
                  <span
                    className="fw-bold text-center"
                    style={{ flex: "0 0 60px", color: "#0d4f5c" }}
                  >
                    {row.pct}
                  </span>
                  <span
                    style={{
                      flex: 1,
                      color: "#6b6254",
                      fontSize: "11px",
                      fontStyle: "italic",
                    }}
                  >
                    {row.note}
                  </span>
                  {currentAgeRow === idx && (
                    <span style={{ fontSize: "14px", color: "#1a5c2e" }}>
                      ✓
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Key Notes ─────────────────────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
              Key Notes & Conditions
            </p>
            <div className="card mb-3">
              {(showAllNotes ? KEY_NOTES : KEY_NOTES.slice(0, 3)).map(
                (note, idx) => (
                  <div
                    key={idx}
                    className="d-flex gap-2 px-3 py-2 align-items-start"
                    style={{
                      borderBottom: "1px solid #f0ebe0",
                      fontSize: "11.5px",
                      color: "#6b6254",
                      lineHeight: "1.5",
                    }}
                  >
                    <span
                      style={{
                        color: "#b8860b",
                        flexShrink: 0,
                        marginTop: "1px",
                      }}
                    >
                      ◆
                    </span>

                    <span>{note}</span>
                  </div>
                ),
              )}

              {KEY_NOTES.length > 3 && (
                <div className="text-center p-2">
                  <button
                    style={{
                      backgroundColor: showAllNotes ? "#e8f5ef" : "#1bb367",
                      color: showAllNotes ? "#1bb367" : "#fff",
                      border: "2px solid #1bb367",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                    onClick={() => setShowAllNotes(!showAllNotes)}
                  >
                    {showAllNotes ? "Show Less ▲" : "Show More ▼"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── Fixed bottom Pay Now ──────────────────────────────────────── */}
      <div className="fixed-bottom-center p-2 py-1">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <small>
                <input
                  type="checkbox"
                  checked={isChecked}
                  className="form-check-input terms_checkbox me-2"
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                By tapping{" "}
                <strong style={{ color: "#1bb367" }}>"Pay Now"</strong> you are
                accepting our{" "}
                <a
                  href="javascript:void(0);"
                  onClick={() => setShow(true)}
                  className="text-decoration-none"
                >
                  Terms &amp; conditions
                </a>
              </small>
              <button
                className="btn btn-success w-100 p-2 rounded-pill border-0 mt-1"
                onClick={handlePayNow}
                disabled={!isChecked || !result}
                style={{ backgroundColor: "#1bb367" }}
              >
                {result ? `Pay Now  (Rs. ${fmtPKR(result.final)})` : "Pay Now"}
              </button>
              <div className="d-flex justify-content-end align-items-end mt-1">
                <p className="custome-textfont mb-0 text-end me-1 text-secondary">
                  Powered By
                </p>
                <img
                  src="/assets/NewMiniapp/powerd-by-log.png"
                  alt="Logo"
                  className="img-fluid"
                  width={40}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <TermsModal
        show={show}
        handleClose={() => setShow(false)}
        terms={terms}
      />
    </div>
  );
};

const Travel = () => {
  const [userData, setUserData] = useState(null);
  const [activeSub, setActiveSub] = useState(null); // null=loading, false=none, obj=found
  const [subChecked, setSubChecked] = useState(false);
  const { isLoading, setIsLoading } = useLoading();
  const [customerNumber, setCustomerNumber] = useState(null);
  const type = "travel";

  // ── Auth ──────────────────────────────────────────────────────────────────
  const getUserAuthCodeResult = (jsonResult) => {
    const result = JSON.parse(jsonResult);
    try {
      if (result.status === "SUCCESS") {
        const form = new FormData();
        form.append("value", result.authCode);
        axios
          .post(`${TRAVEL_API_BASE}/auth`, form, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.openId) {
              sessionStorage.setItem("user", JSON.stringify(response.data));
              setUserData(response.data);
              setCustomerNumber(response.data.userMsisdn);
            } else {
              Swal.fire({
                icon: "info",
                allowOutsideClick: false,
                title: "Something went wrong. Please try again later!",
                confirmButtonText: "Retry",
              }).then(() => authenticateUser());
            }
          })
          .catch((error) => {
            console.error(error);
            setIsLoading(false);
          });
      } else {
        Swal.fire({
          allowOutsideClick: false,
          title: "Please Share the information for Services",
          confirmButtonText: "Retry",
        }).then((r) => {
          if (r.isConfirmed) authenticateUser();
          else setIsLoading(false);
        });
      }
    } catch (error) {
      console.error("Error processing auth code:", error);
      setIsLoading(false);
    }
  };

  const authenticateUser = () => {
    setIsLoading(true);
    const scopes = [
      "USER_MSISDN",
      "USER_NAME",
      "OPEN_ID",
      "UNION_ID",
      "USER_BIRTHDAY",
    ];
    window.mp.getUserAuthCode(scopes);
    window.getUserAuthCodeResult = getUserAuthCodeResult;
  };

  // ── Check subscription (one call — single active sub per customer) ─────────
  const fetchSubscriptionStatus = async (custNum) => {
    setIsLoading(true);
    try {
      const res = await fetch(
        `${TRAVEL_API_BASE}/travel-insurance/subscription?customerNumber=${custNum}&service=TravelInsurance`,
        // { headers: { Authorization: AUTH_HEADER } }
      );
      const data = await res.json();
      setActiveSub(
        data?.responseCode === "0000" && data?.data ? data.data : false,
      );
    } catch (err) {
      console.error("Subscription check error:", err);
      setActiveSub(false);
    } finally {
      setSubChecked(true);
      setIsLoading(false);
    }
  };

  // Called from TravelScreen after successful payment + subscribe API
  const handleSubscriptionSuccess = (subData) => {
    setActiveSub(subData);
  };

  // Called from TravelActiveSubscription after successful unsubscribe
  const handleUnsubscribe = () => {
    setActiveSub(false);
    setSubChecked(true);
  };

  // ── Effects ───────────────────────────────────────────────────────────────
  useEffect(() => {
    setIsLoading(true);
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser) {
      setIsLoading(false);
      setUserData(sessionUser);
      setCustomerNumber(sessionUser.userMsisdn);
    } else {
      authenticateUser();
    }
  }, []);

  useEffect(() => {
    if (userData && customerNumber) {
      fetchSubscriptionStatus(customerNumber);
    }
  }, [userData, customerNumber]);

  const { terms } = getInsuranceData(type);

  if (isLoading || !subChecked) return null;

  const sessionUser = JSON.parse(sessionStorage.getItem("user"));

  // ── Active subscription found ─────────────────────────────────────────────
  if (userData && activeSub) {
    return (
      <div>
        <Header_packages title="Travel Insurance" />
        <Header userSession={sessionUser} />
        <TravelActiveSubscription
          subscription={activeSub}
          customerNumber={customerNumber}
          terms={terms}
          onUnsubscribe={handleUnsubscribe}
        />
      </div>
    );
  }

  // ── No subscription — show calculator ────────────────────────────────────
  return (
    <div>
      <Header_packages title="Travel Insurance" />
      <Header userSession={sessionUser} packageData="notActive" />
      <TravelScreen
        terms={terms}
        userData={userData}
        onSubscriptionSuccess={handleSubscriptionSuccess}
      />
    </div>
  );
};

export default Travel;
